/**
 * Created by hp on 2017/8/7.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';

class MainPopupTabItem extends Component {
    constructor() {
        super();
        this.handleMineCategory = this.handleMineCategory.bind(this);
        this.handleResetCategory = this.handleResetCategory.bind(this);
    }

    /**
     * 订阅分类
     * @param e
     */
    handleMineCategory(e) {
        let categoryId = parseInt(e.target.dataset.id, 10);
        const {mineCategories, subCategories, allCategories} = this.props;

        // 订阅我的栏目
        let category = subCategories.find(function (item) {
            return item.id === categoryId;
        });
        mineCategories.push(category);

        // 剔除选择的栏目
        allCategories.filter((parentCategories) => {
            let newSubCategory = parentCategories.sub_category.filter((category) => {
                return categoryId !== category.id;
            });
            parentCategories.sub_category = newSubCategory;
            return parentCategories;
        });

        this.props.dispatch({
            type: 'MAIN_SUBSCRIBE_CATEGORY',
            payload: {mineCategories, allCategories}
        })
    }

    /**
     * 重置分类
     * @param e
     */
    handleResetCategory(e) {
        let parentId = parseInt(e.target.dataset.parentId, 10);
        let categoryId = parseInt(e.target.dataset.id, 10);
        const {subCategories, allCategories} = this.props;

        // 从我订阅的分类中剔除
        let selectCategory = {};
        let newMineCategories = subCategories.filter((item) => {
            if (item.id === categoryId) {
                selectCategory = item;
            }
            return categoryId !== item.id;
        });

        // 恢复到对应分类
        allCategories.filter((parentCategories) => {
            if (parentCategories.id === parentId) {
                parentCategories.sub_category.push(selectCategory);
            }
            return parentCategories;
        });

        this.props.dispatch({
            type: 'MAIN_SUBSCRIBE_CATEGORY',
            payload: {mineCategories: newMineCategories, allCategories}
        })
    }

    render() {
        const {name, subCategories, isBindMine} = this.props;
        return (
            <div className="main-popup-tab-item">
                <p className="pop-title">{name}</p>
                <div className="pop-content">
                    {subCategories.map((category, index) => (
                        isBindMine ?
                            (category.id !== 0 &&
                            <p className="ppc-item" key={category.id}>
                                    <span className="wk-pointer-hand" data-id={category.id}
                                          data-parent-id={category.parent_id}
                                          onClick={isBindMine ? this.handleResetCategory : this.handleMineCategory}>{category.name}</span>
                            </p>)
                            :
                            <p className="ppc-item" key={category.id}>
                                <span className="wk-pointer-hand" data-id={category.id} data-parent-id={category.parent_id}
                                      onClick={isBindMine ? this.handleResetCategory : this.handleMineCategory}>{category.name}</span>
                            </p>
                    ))}
                </div>
            </div>
        )
    }
}

export default connect((state) => ({
    subscribedCategoryFlag: state.main.subscribedCategoryFlag,
    mineCategories: state.main.category.data.subd,
    allCategories: state.main.category.data.all,
}))(MainPopupTabItem);


// WEBPACK FOOTER //
// ./src/components/main/MainPopupTabItem.js